import { useField } from 'react-final-form';
import { PmuCaseType } from '../pmuDemandTypes';

export const usePmuCaseTypeFormValue = () => {
  const caseTypeField = useField('caseType', { subscription: { value: true } });
  return {
    value: caseTypeField.input.value as PmuCaseType | undefined,
  };
};
